import { type FC, useEffect, useState } from "react";
import { Button, Spinner, Text, TimeProgressBar } from "../../../primitives";

const WAITING_DURATION_MS = 60_000;

type WaitingStepProps = {
	onClose: () => void;
};

export const WaitingStep: FC<WaitingStepProps> = ({ onClose }) => {
	const [takingLonger, setTakingLonger] = useState(false);

	useEffect(() => {
		const timer = setTimeout(() => setTakingLonger(true), WAITING_DURATION_MS);
		return () => clearTimeout(timer);
	}, []);

	return (
		<div
			className="flex flex-col items-center gap-6 px-6 py-10 text-center"
			data-testid="waiting-step"
		>
			<Spinner size="lg" />
			<div className="flex flex-col items-center gap-2">
				<Text type="title" color="primary">
					Extracting and analyzing your documents…
				</Text>
				<Text className="mt-1" type="body" color="secondary" data-testid="waiting-step-subtext">
					If you close this window, we'll notify you once this is complete.
				</Text>
				{takingLonger && (
					<Text
						type="body"
						color="tertiary"
						className="mt-2"
						data-testid="waiting-step-delay-message"
					>
						This is taking longer than usual.
					</Text>
				)}
			</div>
			<TimeProgressBar totalDurationMs={WAITING_DURATION_MS} />
			<Button
				color="secondary"
				variant="outline"
				onClick={onClose}
				data-testid="waiting-step-close-btn"
				trackingId="bond-request-modal-waiting-close"
			>
				Close
			</Button>
		</div>
	);
};
